import React from 'react';
import PhotoModerationTab from '../../../../../components/Locations/PhotoModerationTab';
import { getLocationId } from '../../../utils/locationTransformers';

const PhotosTab = ({ selectedLocation }) => (
  <PhotoModerationTab locationId={getLocationId(selectedLocation)} />
);

export default PhotosTab;
